export const multiViewMovil = `
<svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect opacity="0.4" x="1.1956" y="0.858689" width="33.4246" height="22.283" rx="2.59969" stroke="white" stroke-width="0.742768"/>
    <path d="M17.9102 0.9375V23.416" stroke="#74767A" stroke-width="0.89914"/>
    <path d="M1.27344 12.1768H34.5416" stroke="#74767A" stroke-width="0.89914"/>
</svg>
`;